import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.success.status_eyebrow": "To'lov holati",
    "tk.success.paid.eyebrow": "To'lov qabul qilindi",
    "tk.success.paid.title_a": "Taklifnomangiz",
    "tk.success.paid.title_em": "tayyor",
    "tk.success.paid.lead_live": "Havolani mehmonlarga yuboring — ularning javoblari kabinetingizda ko'rinadi.",
    "tk.success.share_telegram": "Telegram'da ulashish",
    "tk.success.qr": "QR kod",
    "tk.success.qr_caption": "Skanerlasin yoki chop eting",
    "tk.success.qr_alt": "Taklifnoma havolasining QR kodi",
    "tk.success.open_link": "Havolani ochish",
    "tk.success.copy_link": "Havoladan nusxa olish",
    "tk.success.crumbs": "Sahifa yo'li",

    "tk.success.share.title_a": "Sizning taklifnomangiz",
    "tk.success.share.title_em": "tirik",
    "tk.success.share.facebook": "Facebook",
    "tk.success.share.email": "Email",
    "tk.success.share.more": "Boshqasi",
    "tk.success.share.channels": "Ulashish usullari",
    "tk.success.share.instagram_hint": "Instagram uchun: havolani nusxa oling va Story yoki DM'ga joylang.",

    "tk.success.url.title_a": "Taklifnoma",
    "tk.success.url.title_em": "havolasi",
    "tk.success.url.lead": "Taklifnomangiz manzilini xohlaganingizdek o'zgartiring. Faqat lotin harflari, raqamlar va chiziqlar.",
    "tk.success.url.label": "Havola manzili",
    "tk.success.url.checking": "Tekshirilmoqda…",
    "tk.success.url.available": "Mavjud — saqlash mumkin",
    "tk.success.url.taken": "Bu manzil band",
    "tk.success.url.invalid": "Faqat lotin harflari, raqam va chiziqlar",
    "tk.success.url.current": "Hozirgi manzil:",
    "tk.success.url.saving": "Saqlanmoqda…",
    "tk.success.url.saved": "Saqlandi",
    "tk.success.url.save_failed": "Saqlanmadi",

    "tk.success.wishes.title_a": "Mehmonlar",
    "tk.success.wishes.title_em": "tilaklari",
    "tk.success.wishes.lead": "Mehmonlar taklifnomangizga qoldirgan tilaklar. Noo'rin yozuvni o'chirib tashlashingiz mumkin.",
    "tk.success.wishes.count": "{n} ta tilak",
    "tk.success.wishes.empty": "Hozircha tilaklar yo'q — taklifnomangiz ulashilgach, mehmonlar yozadi.",
    "tk.success.wishes.confirm": "Bu tilakni o'chirishni xohlaysizmi?",
    "tk.success.wishes.today": "Bugun",
    "tk.success.wishes.yesterday": "Kecha",
    "tk.success.wishes.date": "{d}-{m}, {time}",
    "tk.success.month.1": "yanvar",
    "tk.success.month.2": "fevral",
    "tk.success.month.3": "mart",
    "tk.success.month.4": "aprel",
    "tk.success.month.5": "may",
    "tk.success.month.6": "iyun",
    "tk.success.month.7": "iyul",
    "tk.success.month.8": "avgust",
    "tk.success.month.9": "sentabr",
    "tk.success.month.10": "oktabr",
    "tk.success.month.11": "noyabr",
    "tk.success.month.12": "dekabr",
  },
  ru: {
    "tk.success.status_eyebrow": "Статус оплаты",
    "tk.success.paid.eyebrow": "Оплата получена",
    "tk.success.paid.title_a": "Ваше приглашение",
    "tk.success.paid.title_em": "готово",
    "tk.success.paid.lead_live": "Отправьте ссылку гостям — их ответы появятся в вашем кабинете.",
    "tk.success.share_telegram": "Отправить в Telegram",
    "tk.success.qr": "QR-код",
    "tk.success.qr_caption": "Отсканируйте или распечатайте",
    "tk.success.qr_alt": "QR-код ссылки на приглашение",
    "tk.success.open_link": "Открыть ссылку",
    "tk.success.copy_link": "Скопировать ссылку",
    "tk.success.crumbs": "Навигационная цепочка",

    "tk.success.share.title_a": "Ваше приглашение",
    "tk.success.share.title_em": "в эфире",
    "tk.success.share.facebook": "Facebook",
    "tk.success.share.email": "E-mail",
    "tk.success.share.more": "Другое",
    "tk.success.share.channels": "Способы отправки",
    "tk.success.share.instagram_hint": "Для Instagram: скопируйте ссылку и вставьте её в сторис или в директ.",

    "tk.success.url.title_a": "Ссылка на",
    "tk.success.url.title_em": "приглашение",
    "tk.success.url.lead": "Измените адрес приглашения так, как вам удобно. Только латинские буквы, цифры и дефисы.",
    "tk.success.url.label": "Адрес ссылки",
    "tk.success.url.checking": "Проверяем…",
    "tk.success.url.available": "Свободен — можно сохранить",
    "tk.success.url.taken": "Этот адрес уже занят",
    "tk.success.url.invalid": "Только латинские буквы, цифры и дефисы",
    "tk.success.url.current": "Текущий адрес:",
    "tk.success.url.saving": "Сохраняем…",
    "tk.success.url.saved": "Сохранено",
    "tk.success.url.save_failed": "Не удалось сохранить",

    "tk.success.wishes.title_a": "Пожелания",
    "tk.success.wishes.title_em": "гостей",
    "tk.success.wishes.lead": "Пожелания, которые гости оставили в вашем приглашении. Неуместную запись можно удалить.",
    "tk.success.wishes.count": "Пожеланий: {n}",
    "tk.success.wishes.empty": "Пожеланий пока нет — гости напишут их, когда вы поделитесь приглашением.",
    "tk.success.wishes.confirm": "Удалить это пожелание?",
    "tk.success.wishes.today": "Сегодня",
    "tk.success.wishes.yesterday": "Вчера",
    "tk.success.wishes.date": "{d} {m}, {time}",
    "tk.success.month.1": "января",
    "tk.success.month.2": "февраля",
    "tk.success.month.3": "марта",
    "tk.success.month.4": "апреля",
    "tk.success.month.5": "мая",
    "tk.success.month.6": "июня",
    "tk.success.month.7": "июля",
    "tk.success.month.8": "августа",
    "tk.success.month.9": "сентября",
    "tk.success.month.10": "октября",
    "tk.success.month.11": "ноября",
    "tk.success.month.12": "декабря",
  },
  en: {
    "tk.success.status_eyebrow": "Payment status",
    "tk.success.paid.eyebrow": "Payment received",
    "tk.success.paid.title_a": "Your invitation is",
    "tk.success.paid.title_em": "ready",
    "tk.success.paid.lead_live": "Send the link to your guests — their replies will show up in your account.",
    "tk.success.share_telegram": "Share on Telegram",
    "tk.success.qr": "QR code",
    "tk.success.qr_caption": "Let guests scan it, or print it",
    "tk.success.qr_alt": "QR code for the invitation link",
    "tk.success.open_link": "Open link",
    "tk.success.copy_link": "Copy link",
    "tk.success.crumbs": "Breadcrumb",

    "tk.success.share.title_a": "Your invitation is",
    "tk.success.share.title_em": "live",
    "tk.success.share.facebook": "Facebook",
    "tk.success.share.email": "Email",
    "tk.success.share.more": "More",
    "tk.success.share.channels": "Ways to share",
    "tk.success.share.instagram_hint": "For Instagram: copy the link and paste it into a Story or DM.",

    "tk.success.url.title_a": "Invitation",
    "tk.success.url.title_em": "link",
    "tk.success.url.lead": "Change your invitation's address however you like. Latin letters, numbers and hyphens only.",
    "tk.success.url.label": "Link address",
    "tk.success.url.checking": "Checking…",
    "tk.success.url.available": "Available — you can save it",
    "tk.success.url.taken": "This address is taken",
    "tk.success.url.invalid": "Latin letters, numbers and hyphens only",
    "tk.success.url.current": "Current address:",
    "tk.success.url.saving": "Saving…",
    "tk.success.url.saved": "Saved",
    "tk.success.url.save_failed": "Not saved",

    "tk.success.wishes.title_a": "Guest",
    "tk.success.wishes.title_em": "wishes",
    "tk.success.wishes.lead": "Wishes your guests left on your invitation. You can delete anything inappropriate.",
    "tk.success.wishes.count": "Wishes: {n}",
    "tk.success.wishes.empty": "No wishes yet — guests will write once you share your invitation.",
    "tk.success.wishes.confirm": "Do you want to delete this wish?",
    "tk.success.wishes.today": "Today",
    "tk.success.wishes.yesterday": "Yesterday",
    "tk.success.wishes.date": "{d} {m}, {time}",
    "tk.success.month.1": "January",
    "tk.success.month.2": "February",
    "tk.success.month.3": "March",
    "tk.success.month.4": "April",
    "tk.success.month.5": "May",
    "tk.success.month.6": "June",
    "tk.success.month.7": "July",
    "tk.success.month.8": "August",
    "tk.success.month.9": "September",
    "tk.success.month.10": "October",
    "tk.success.month.11": "November",
    "tk.success.month.12": "December",
  },
};

export default dict;
